<template>
  <div>
    <div class="overtimeStatistics">
      <Row :gutter="4">
        <Col span="4">
          <Input search v-model="name" :placeholder="$t('MCM.extraContributionManagement.name')"
                 @on-search="searchName()"/>
        </Col>
        <Col span="4">
          <DatePicker type="month" :placeholder="$t('MCM.extraContributionManagement.extraContributionDate')" v-model="startDate" @on-change="searchStartDate()" :transfer="true" style="width:100%;"></DatePicker>
        </Col>
        <Col span="4">
            <span @click="search()">
                <Button type="primary" @click="overtimeStatisticsModal = true" v-hasPermission="['operationKpiConfigurationManagement:overtimeManagement:add_overtime_duty']">{{$t('MCM.extraContributionManagement.addExtraContribution')}}</Button>
            </span>    
            <Button type="warning" :loading="modal_loading" @click="exportList" v-hasPermission="['operationKpiConfigurationManagement:overtimeManagement:export']">{{$t('common.export') }}</Button> 
        </Col>
      </Row>
    </div>
    <Modal v-model="overtimeStatisticsModal" :title="$t('MCM.extraContributionManagement.addExtraContribution')"
           :loading="loading" @on-ok="overtimeStatisticsSubmit('overtimeStatisticsForm')"
           @on-cancel="overtimeStatisticsReset('overtimeStatisticsForm')" :mask-closable="false"
           :okText="$t('alarms.common.add')" :cancelText="$t('alarms.common.cancel')">
      <Form ref="overtimeStatisticsForm" :model="overtimeStatisticsForm" :label-width="100" :rules="ruleValidate">
        <!-- 姓名 -->
        <FormItem :label="$t('MCM.extraContributionManagement.name')" prop="name">
          <Select v-model="overtimeStatisticsForm.name" style="width:300px;" placeholder="Please select">
            <Option :value="item.id" v-for="item in nameList" v-bind:key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <!-- 额外贡献年月 -->
        <FormItem :label="$t('MCM.extraContributionManagement.extraContributionDate')" prop="overtimeYearMonth">
          <DatePicker type="month"
                      :placeholder="$t('MCM.extraContributionManagement.pleaseSelectExtraContributionDate')"
                      v-model="overtimeStatisticsForm.overtimeYearMonth" style="width:300px;"
                      @on-change="overtimeStatisticsForm.overtimeYearMonth=$event" format="yyyy-MM"></DatePicker>
        </FormItem>
        <!-- 额外贡献时间 -->
        <FormItem :label="$t('MCM.extraContributionManagement.extraContributionTime')" prop="overTime">
          <InputNumber :min="0" v-model="overtimeStatisticsForm.overTime" style="width:120px;"
                       :placeholder="$t('MCM.extraContributionManagement.pleaseEnterExtraContributionTime')"></InputNumber>
          {{$t('configuration_management.schedules.hour')}}
        </FormItem>
        <!-- 描述 -->
        <FormItem :label="$t('MCM.extraContributionManagement.description')" prop="remark">
          <Input v-model="overtimeStatisticsForm.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}"
                 style="width:300px;"></Input>
        </FormItem>
      </Form>
    </Modal>
    <table-overtime-statistics></table-overtime-statistics>
  </div>
</template>
<script>
  import TableOvertimeStatistics from '../overtime_management/TableOvertimeStatistics'

  var tableOvertimeStatistics = TableOvertimeStatistics;
  export default {
    components: {
      TableOvertimeStatistics
    },
    data() {
      return {
        modal_loading: false,
        name: '',
        startDate: '',
        loading: true,
        overtimeStatisticsModal: false,
        nameList: [],
        overtimeStatisticsForm: {
          name: '',
          overtimeYearMonth: '',
          overTime: 0,
          remark: ''
        },
        ruleValidate: {
          name: [
            {
              required: true,
              message: this.$t('MCM.extraContributionManagement.PleaseSelectName'),
              trigger: 'change',
              type: 'number'
            }
          ],
          overtimeYearMonth: [
            {required: true, message: this.$t('MCM.extraContributionManagement.pleaseSelectExtraContributionDate')}
          ],
          remark: [
            {
              required: false,
              message: this.$t('MCM.extraContributionManagement.pleaseEnterDescription'),
              trigger: 'blur'
            },
            {
              type: 'string',
              max: 10000,
              message: this.$t('MCM.extraContributionManagement.EnterMaximumOfCharacters'),
              trigger: 'blur'
            }
          ],
          overTime: [
            {required: true, message: this.$t('MCM.extraContributionManagement.pleaseEnterExtraContributionTime')}
          ]
        }
      }
    },
    methods: {
      /************************查询条件**************************************/
      // 按姓名搜索
      searchName: function () {
        eventBus.$emit('name', this.name);
        tableOvertimeStatistics.methods.showAll();
      },
      // 按额外贡献年月筛选
      searchStartDate: function () {
        eventBus.$emit('startDate', this.startDate);
        tableOvertimeStatistics.methods.showAll();
      },
      /************************添加*取消*****************************************/
      search: function () {
        this.$api.user.getOperationUsers({})
          .then(res => {
            this.nameList = res.data;
          })
      },
      overtimeStatisticsSubmit: function (name) {
        this.$refs[name].validate(valid => {
          if (valid) {
            this.$api.kpiOvertimeRecordByUser.checkKpiOvertimeRecordByUser({
              "userId": this.overtimeStatisticsForm.name,
              "overtimeYearMonth": this.overtimeStatisticsForm.overtimeYearMonth
            })
              .then(res => {
                if (res.status == 200) {
                  // 添加
                  this.$api.kpiOvertimeRecordByUser.insertOrUpdate({
                    "userId": this.overtimeStatisticsForm.name,
                    "overTime": this.overtimeStatisticsForm.overTime,
                    "overtimeYearMonth": this.overtimeStatisticsForm.overtimeYearMonth,
                    "remark": this.overtimeStatisticsForm.remark
                  })
                    .then(res => {
                      setTimeout(() => {
                        tableOvertimeStatistics.methods.showAll();
                        this.$refs[name].resetFields();
                        this.loading = false;
                        this.$nextTick(() => {
                          this.loading = true;
                        });
                        this.$Message.success(this.$t('common.addSuccess'));
                        this.overtimeStatisticsModal = false;
                      }, 1000);
                    })
                }
              })
              .catch(err => {
                if (err.status == 400) {
                  this.loading = false;
                  setTimeout(() => {
                    this.loading = true
                  }, 0)
                  this.$Modal.error({
                    title: this.$t('common.systemPrompt'),
                    content: this.$t('MCM.msg.contributionRepeat')
                  });
                }
              })

          } else {
            this.loading = false;
            setTimeout(() => {
              this.loading = true
            }, 0)
            this.$Message.error(this.$t('common.addFail'));
          }
        });

      },
      overtimeStatisticsReset: function (name) {
        this.$refs[name].resetFields();
      },
      /************************导出******************************************/
      exportList: function () {
        this.modal_loading = true
        this.$Message.loading({
          duration: 0,
          content: this.$t('common.exporting')
        })
        // 下载Excel 文件
        this.$api.kpiOvertimeRecordByUser.exportKpiOvertimeRecordByUser({
          "userName": this.name,
          "overtimeYearMonth": this.startDate
        })
          .then(res => {
            let fileName = this.$t('MCM.exportFile.operationContribution')
            let blob = new Blob([res.data], {type: 'application/x-xls'})
            if (window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              var link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = fileName;
              link.click();
              window.URL.revokeObjectURL(link.href);
            }
            this.modal_loading = false;
            this.$Message.destroy();
            this.$Message.success(this.$t('common.exportSuccess'));
          })
      }
    }
  }
</script>
<style scoped>
  .overtimeStatistics {
    width: 100%;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/configuration/operation_kpi_configuration_management/overtime_management/AddOvertimeStatistics.vue